import styled from "styled-components"

import padding from "@irati/ui/src/global/padding"
import {H4, H2} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"

export const StyledH4 = styled(H4)`
  font-family: ${({theme}) => theme.font.light};
`

export const StyledH2 = styled(H2)`
  font-family: ${({theme}) => theme.font.light};
`

export const MarginRightButton = styled(Button)`
  margin-right: ${padding.medium};
`
